import { scheduleApi } from '../api/schedule'

export const {
  useGetSchedulesQuery,
  useGetScheduleAvailabilitiesQuery,
  useGetBusySlotsQuery,
  useLazyGetScheduleAvailabilitiesQuery,
  useCreateScheduleMutation,
  useCreateScheduleExceptionMutation,
  useDeleteScheduleMutation,
} = scheduleApi
